export function VerticalTextDivider(): JSX.Element {
  return <div className="h-4 w-px flex-none border-r border-[rgb(225,231,234)]" />;
}
